<template>
    <contactWire-add-form></contactWire-add-form>
</template>


<script>

    import ContactWireAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            ContactWireAddForm,
        },

    }
</script>

